import React, { useState } from 'react';
import { useIntl } from 'react-intl';

import BRButton from 'components/BRButton/BRButton';

import { ReactComponent as ChevronLeft } from 'assets/bosta-icons/Chevron-left.svg';
import { ReactComponent as ChevronRight } from 'assets/bosta-icons/Chevron-right.svg';
import { ReactComponent as StaticLoadingIcon } from 'assets/bosta-icons/StaticLoadingIcon.svg';

import './ImageCarousel.less';

export function ImageCarousel({ images, isLoading }) {
  const intl = useIntl();
  const [currentImage, setCurrentImage] = useState(0);

  const handlePrevious = () => {
    setCurrentImage((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentImage((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const isFirstImage = currentImage === 0;
  const isLastImage = currentImage === images.length - 1;

  if (isLoading) {
    return (
      <div className="br-lost-orders_image-carousel_container">
        <div className="br-lost-orders_image-carousel_loading_container">
          <StaticLoadingIcon
            className="br-lost-orders_image-carousel_loading_icon"
            style={{ width: 32, height: 32 }}
          />
        </div>
      </div>
    );
  }

  if (!images?.length) {
    return (
      <div className="br-lost-orders_image-carousel_container">
        <div className="br-lost-orders_image-carousel_loading_container">
          {intl.formatMessage({
            id: 'ops_control.lost_orders.proof_modal.image_carousel.no_images_available'
          })}
        </div>
      </div>
    );
  }

  return (
    <div className="br-lost-orders_image-carousel_container">
      <img
        className="br-lost-orders_image-carousel_image"
        src={images[currentImage]}
        alt="proof"
      />

      <div className="br-lost-orders_image-carousel_navigation">
        <BRButton
          type={'link-gray'}
          onClick={handlePrevious}
          disabled={isFirstImage}
          className="br-lost-orders_image-carousel_button"
          label={<ChevronLeft style={{ stroke: 'white' }} />}
        />

        <div className="br-lost-orders_image-carousel_counter">
          {intl.formatMessage(
            {
              id: 'ops_control.lost_orders.proof_modal.image_carousel.picture'
            },
            {
              currentImage: currentImage + 1,
              imagesLength: images.length
            }
          )}
        </div>

        <BRButton
          type={'link-gray'}
          onClick={handleNext}
          disabled={isLastImage}
          className="br-lost-orders_image-carousel_button"
          label={<ChevronRight style={{ stroke: 'white' }} />}
        />
      </div>
    </div>
  );
}
